import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'

import { z } from 'zod'

import {
	Divider,
	Link,
	Subtitle,
	Title,
} from '@/shared/auth/components/common/card'
import { AuthErrorComponent } from '@/shared/auth/components/common/error-component'
import { PasswordResetFlow } from '@/shared/auth/components/forms/password-reset-flow'

import { Button } from '@/components/ui/button'

const searchSchema = z.object({
	email: z.string().optional(),
})

export const Route = createFileRoute('/_auth/forgot-password')({
	validateSearch: zodValidator(searchSchema),

	head: () => ({
		meta: [
			{
				title: 'Forgot Password | BitLyft AIR®',
			},
		],
	}),

	component: RouteComponent,
	errorComponent: AuthErrorComponent,
})

function RouteComponent() {
	const { email } = Route.useSearch()

	return (
		<>
			<Title>Forgot Password</Title>
			<Subtitle>Enter your email address to reset your password.</Subtitle>

			<PasswordResetFlow initialEmail={email} />

			<Divider />

			<Button
				variant="link"
				nativeButton={false}
				className="dark:text-primary-foreground"
				render={<Link to="/login">Return to Sign In</Link>}
			/>
		</>
	)
}
